
import React from "react";
import BackButton from "../../Button/BackButton";
import BidCard from "./BidCard";
import "./BidsList.css";
import {
  ListPageWrapper,
  ListTopBar,
  ListTopBarLeft,
  ListTopBarTitle,
  ListTopBarSubtitle,
  IconBtn,
  SearchBarWrapper,
  SearchInput,
  BidCardsWrapper,
} from "../styles.bids";

const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="7" cy="7" r="5" stroke="#293142" strokeWidth="1.5" fill="none"/>
    <path d="M11 11l3 3" stroke="#293142" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const HelpIcon = () => <img src="/logos/bids_help.svg" width="20" height="20" alt="" />;

const BidsList = ({
  status,
  navigate,
  showSearch,
  toggleSearch,
  searchQuery,
  setSearchQuery,
  biddingSessionsStatus,
  biddingSessionsError,
  title,
  filtered,
}) => {
  return (
    <ListPageWrapper>
      <ListTopBar>
        <BackButton />
        <ListTopBarLeft>
          <ListTopBarTitle>{title}</ListTopBarTitle>
          <ListTopBarSubtitle>
            {filtered.length} {status === "live" ? "bids are open" : "bids"}
          </ListTopBarSubtitle>
        </ListTopBarLeft>
        <IconBtn onClick={toggleSearch}>
          <SearchIcon />
        </IconBtn>
        <IconBtn onClick={() => navigate("/bids/faq")}>
          <HelpIcon />
        </IconBtn>
      </ListTopBar>

      {showSearch && (
        <SearchBarWrapper>
          <SearchInput>
            <SearchIcon />
            <input
              autoFocus
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by product, bid ID or name"
              className="bids-list-search-input"
            />
          </SearchInput>
        </SearchBarWrapper>
      )}


      <BidCardsWrapper>
        {biddingSessionsStatus === "BEGIN" && (
          <div className="bids-list-state-message">
            Loading bids…
          </div>
        )}

        {biddingSessionsStatus === "FAIL" && (
          <div className="bids-list-state-message bids-list-state-message-error">
            {biddingSessionsError || "Something went wrong. Please try again."}
          </div>
        )}

        {biddingSessionsStatus === "DONE" && filtered.length === 0 && (
          <div className="bids-list-state-message">
            No bids available
          </div>
        )}

        {filtered?.map((bid) => (
          <BidCard
            key={bid.id}
            bid={bid}
            onClick={() =>
              navigate(`/bids/details/${bid.id}`, { state: { bidId: bid.id, status: bid.status || status } })
            }
          />
        ))}
      </BidCardsWrapper>
    </ListPageWrapper>
  );
};

export default BidsList;
